import Cookies from 'js-cookie';
import jwt_decode from 'jwt-decode';
import Logging from '@/logging';

const TokenKey = 'Admin-Token';

export function getToken() {
	return Cookies.get(TokenKey);
}

export const getIdToken = () => {
	return localStorage.getItem('rslt_id_token');
};

export const getAccessToken = () => {
	return localStorage.getItem('rslt_access_token');
};

export const getSubFromToken = () => {
	try {
		const id_token = localStorage.getItem('rslt_id_token');
		return jwt_decode(id_token).sub;
	} catch (e) {
		Logging.error(e);
	}
};

export function determineLoggedInStatus() {
	const access_token = localStorage.getItem('rslt_access_token');
	if (!access_token) {
		return false;
	}

	try {
		const expTime = jwt_decode(access_token).exp;

		if (expTime < new Date().getTime() / 1000) {
			return false;
		} else {
			return true;
		}
	} catch (e) {
		Logging.error('Error: ', e);
		return false;
	}
}

export function getRolesFromToken(token) {
	const decodedIdToken = jwt_decode(token);
	const roles = decodedIdToken['cognito:groups'];
	return roles;
}

export function setToken(token) {
	return Cookies.set(TokenKey, token);
}

export function removeToken() {
	return Cookies.remove(TokenKey);
}
